import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";

addMore(Highcharts);

@Component({
  selector: 'widget-loader-error-handler',
  templateUrl: './widget-loader-error-handler.component.html',
  styleUrls: ['./widget-loader-error-handler.component.scss']
})
export class WidgetLoaderErrorHandlerComponent implements OnInit {
  @Input() SPIN;
  @Input() ERRORMESSAGE;
  @Input() ERRORCHART;
  @Input() ERRORTABLE;
  highcharts: typeof Highcharts = Highcharts;

  
  constructor() { }

  ngOnInit() {
  }

}
